import { ConnectedUser } from '@ucc/admin-global-state'

import config from 'config'
import { fetchWithToken } from 'utils'

/**
 * Retrieves the user's logmein infos
 */
const fetchIAm = async (managedAccountKey?: string, childAccountKey?: string): Promise<ConnectedUser> => {
  const externalAdminUrl = config.EXTERNAL_ADMIN_URL
  const queryValues: string[] = []
  if (managedAccountKey) {
    queryValues.push(`managedAccountKey=${managedAccountKey}`)
  }
  if (childAccountKey) {
    queryValues.push(`childAccountKey=${childAccountKey}`)
  }
  const route = `${externalAdminUrl}/ext-admin/rest/me${queryValues.length ? `?${queryValues.join('&')}` : ''}`

  return await fetchWithToken({
    method: 'GET',
    externalUrl: route,
  })
    .then((response: Response) => {
      return response.json()
    })
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })
}

export default fetchIAm
